/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.pushTokenRegistration.internal

import features.pushTokenRegistration.models.UserProfileModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.pushTokenRegistration.internal.PushTokenRegistrationUseCase.Params

internal class PushTokenRegistrationUseCase : AsyncUseCase<UserProfileModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val androidDeviceToken: String?,
        val iosDeviceToken: String?
    )

    private val pushTokenRegistrationService: PushTokenRegistrationService = PushTokenRegistrationServiceImpl()

    override suspend fun run(params: Params): Result<UserProfileModel> {
        return pushTokenRegistrationService.registerPushToken(
            overrideHeaders = params.overrideHeaders,
            androidDeviceToken = params.androidDeviceToken,
            iosDeviceToken = params.iosDeviceToken
        )
    }
}
